const FLAGS: Record<string, string> = {
    FWC: "🏆",
    ALG: "🇩🇿",
    ARG: "🇦🇷",
    MISC: "🌐",
    AUS: "🇦🇺",
    AUT: "🇦🇹",
    BEL: "🇧🇪",
    BIH: "🇧🇦",
    BRA: "🇧🇷",
    CAN: "🇨🇦",
    CPV: "🇨🇻",
    COL: "🇨🇴",
    COD: "🇨🇩",
    CRO: "🇭🇷",
    LMO: "🏅",
    CUW: "🇨🇼",
    CZE: "🇨🇿",
    ECU: "🇪🇨",
    EGY: "🇪🇬",
    ENG: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    FRA: "🇫🇷",
    GER: "🇩🇪",
    GHA: "🇬🇭",
    HAI: "🇭🇹",
    IRN: "🇮🇷",
    IRQ: "🇮🇶",
    CIV: "🇨🇮",
    JPN: "🇯🇵",
    JOR: "🇯🇴",
    MEX: "🇲🇽",
    MAR: "🇲🇦",
    NED: "🇳🇱",
    NZL: "🇳🇿",
    NOR: "🇳🇴",
    PAN: "🇵🇦",
    PAR: "🇵🇾",
    POR: "🇵🇹",
    QAT: "🇶🇦",
    KSA: "🇸🇦",
    SCO: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    SEN: "🇸🇳",
    RSA: "🇿🇦",
    KOR: "🇰🇷",
    ESP: "🇪🇸",
    SWE: "🇸🇪",
    SUI: "🇨🇭",
    TUN: "🇹🇳",
    TUR: "🇹🇷",
    URU: "🇺🇾",
    USA: "🇺🇸",
    UZB: "🇺🇿"
};

export function flag(code: string): string {
    return FLAGS[code] ?? "🏳️";
}
